module.exports = __webpack_public_path__ + "img/MapPicsOasis.dfe602cd.webp";